import { TBorder, TBorderOneSide } from "../utils/types/gui/field.types";

export const generateBorder = (border?: TBorder) => {
  // IF THE USER DOES NOT WANT THE BORDER
  if (!border || border === "none") return;

  // GET THE KEYS TO KNOW WHICH KIND OF TYPE WE ARE USING
  const borderKeys = Object.keys(border);

  // IF WE HAVE WIDTH WE APPLY THE BORDER TO ALL SIDES
  if (borderKeys.includes("width")) {
    const { width, style, color } = border as TBorderOneSide;

    return `${width} ${style ?? "solid"} ${color ?? "#000"}`;
  }

  return;
  // TODO IMPLEMENT FOR DIFFERENT SIDE
  // IF WE HAVE SPECIFIC SIDE BORDER
  // const borders = {};

  // // WE NAVIGATE THROUGH EACH ACTIVED SIDE
  // // AND ADD THE BORDER TO IT
  // borderKeys.forEach((key) => {
  //   const { width, style, color } = border[key] as TBorderOneSide;

  //   borders[`border${key}`] = `${width}px ${style} ${color ?? "#000"}`;
  // });

  // // WE RETURN THE
  // return borders;
};
